var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyPet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_15595)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_85_15595)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4298",
    opacity: 0.24,
    filter: "url(#filter0_f_85_15595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 45,
    width: 26,
    height: 17,
    rx: 8,
    fill: "#8F4BF6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8873 28.8983L20.19 28.5956C20.5943 28.1914 21.1425 27.9643 21.7142 27.9643C22.2859 27.9643 22.8342 28.1914 23.2384 28.5956L23.5411 28.8983C24.0864 29.4436 24.8261 29.75 25.5973 29.75H25.9491C27.5551 29.75 28.8571 28.448 28.8571 26.842C28.8571 25.8697 28.3712 24.9617 27.5622 24.4224C26.652 23.8156 25.8938 23.0073 25.3463 22.0602L24.5249 20.6392C23.9513 19.6469 22.8921 19.0356 21.7459 19.0356C20.6184 19.0356 19.5735 19.6272 18.9934 20.5941L18.074 22.1264C17.5314 23.0308 16.7947 23.8034 15.9171 24.3885L15.8662 24.4224C15.0572 24.9617 14.5713 25.8697 14.5713 26.842C14.5713 28.448 15.8732 29.75 17.4793 29.75H17.8311C18.6023 29.75 19.342 29.4436 19.8873 28.8983Z",
    fill: "#8F4BF6",
    stroke: "#8F4BF6",
    strokeWidth: 1.70456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.018,
    cy: 19.4821,
    r: 1.33929,
    fill: "#8F4BF6",
    stroke: "#8F4BF6",
    strokeWidth: 1.70456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    cx: 28.4111,
    cy: 19.4821,
    r: 1.33929,
    fill: "#8F4BF6",
    stroke: "#8F4BF6",
    strokeWidth: 1.70456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    cx: 18.8447,
    cy: 15.0178,
    r: 1.33929,
    fill: "#8F4BF6",
    stroke: "#8F4BF6",
    strokeWidth: 1.70456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4",
    cx: 24.5844,
    cy: 15.0178,
    r: 1.33929,
    fill: "#8F4BF6",
    stroke: "#8F4BF6",
    strokeWidth: 1.70456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#E5E4F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_85_15595",
    x: 9,
    y: 31,
    width: 54,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_85_15595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_15595",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_15595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPet);
export default __webpack_public_path__ + "static/media/myPet.1092ea6f9a62945e86440c502f002918.svg";
export { ForwardRef as ReactComponent };